<template>
  <div id="vanber">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>平台岗位管理</el-breadcrumb-item>
      <el-breadcrumb-item>岗位发布</el-breadcrumb-item>
    </el-breadcrumb>
    <v-recruiting></v-recruiting>

  </div>
</template>

<script>
import Recruiting from "./components/Recruiting";

export default {
  components: {
    "v-recruiting": Recruiting,
  },
  data() {
    return {
      // active: "recruiting"
    };
  },

  methods: {}
};
</script>

<style scoped lang="scss">
#vanber {
  position: relative;
  padding: 20px;
  .el-breadcrumb {
    margin-bottom: 30px;
  }
}
</style>
